export const RemoveFolder = ({ size = 22, className }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M4.58333 3.66699H8.25L11 6.41699H17.4167C18.4292 6.41699 19.25 7.2378 19.25 8.25033V15.5837C19.25 16.5962 18.4292 17.417 17.4167 17.417H4.58333C3.57081 17.417 2.75 16.5962 2.75 15.5837V5.50033C2.75 4.4878 3.57081 3.66699 4.58333 3.66699"
        stroke="currentColor"
        strokeOpacity="0.9"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.25 11.9163H13.75"
        stroke="currentColor"
        strokeOpacity="0.9"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
